import { render, staticRenderFns } from "./FooterLeicester.vue?vue&type=template&id=77b10a4a&"
import script from "./FooterLeicester.vue?vue&type=script&lang=js&"
export * from "./FooterLeicester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports